import { MOVE_TO_ZONE, RESET_ON_DROP, SET_ACTIONS, SWAP_CARDS, SET_MODALE_SORTER_VALUE, RESET_MODALE_SORTER_VALUE, SET_MODAL_SELECTED_SOTER_ASINITIAL, RESET_MODAL_SORTER, SET_MODAL_SOTERS } from './actionTypes';

// // FIXME: we use async here, it may cause errors or has latency
// export const addColumn = (toZone, columnId) => (dispatch, getState) => {
//   const allColumns = getState().report.sider.availableColumns;
//   // TODO: if toZone is left sider, then update record disabled state to false, e.g. close or move back to left sider
//   // return dispatch(updateAvailableColumn());
//   return dispatch({
//     type: ADD_COLUMN,
//     payload: { toZone, columnId, allColumns },
//   });
// };

// export const removeColumn = (fromZone, columnId) => (dispatch, getState) => {
//   const allColumns = getState().report.sider.availableColumns;
//   return dispatch({
//     type: REMOVE_COLUMN,
//     payload: { fromZone, columnId, allColumns },
//   });  
// };

export const moveToZone = (targetZone, columnId) => ({
  type: MOVE_TO_ZONE,
  payload: { targetZone, columnId },
});

export const swapCards = (dragId, dropId) => ({
  type: SWAP_CARDS,
  payload: { dragId, dropId },
});

export const setActions = (columnId, actions) => ({
  type: SET_ACTIONS,
  payload: { columnId, actions },
});

export const resetOnDrop = () => ({
  type: RESET_ON_DROP,
});

export const setSorterValue = (fieldsKey, actionKey, value) => ({
  type: SET_MODALE_SORTER_VALUE,
  payload: { fieldsKey, actionKey, value },
});

export const resetSorterValue = () => ({
  type: RESET_MODALE_SORTER_VALUE,
});

export const setModalSelectedValueAsInitial = () => ({
  type: SET_MODAL_SELECTED_SOTER_ASINITIAL,
});

export const resetModalSorter = () => ({
  type: RESET_MODAL_SORTER,
});

export const setModalSoters = (groupSorter, otherSorter) => ({
  type: SET_MODAL_SOTERS,
  payload: { groupSorter, otherSorter },
});



// WEBPACK FOOTER //
// ./src/views/ReportTableSetup/flow/actions.js